import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/info.tsx
var Info = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("circle", {
			cx: "12",
			cy: "12",
			r: "9",
			stroke: "currentColor",
			strokeWidth: "1.5",
			fill: "none"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11 11H12V16",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "11.3438",
			y: "6.95801",
			width: "1.5",
			height: "1.5",
			rx: "0.75",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: "0.5"
		})
	] }) : /* @__PURE__ */ jsx("path", {
		d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.75 10.25C10.3358 10.2501 10 10.5858 10 11C10.0001 11.4141 10.3359 11.7499 10.75 11.75H11.25V16.25C11.25 16.6642 11.5858 16.9999 12 17C12.4142 17 12.75 16.6642 12.75 16.25V11C12.75 10.5858 12.4142 10.25 12 10.25H10.75ZM12 7C11.4478 7.00007 11 7.44776 11 8C11 8.55224 11.4478 8.99993 12 9C12.5523 8.99998 13 8.55227 13 8C13 7.44773 12.5523 7.00002 12 7Z",
		fill: "currentColor"
	})
});
//#endregion
export { Info };
